<template>
  <div class="section-announcement">
    <LadTextCover v-bind="cover" />
    <el-container>
      <el-main>
        <el-row v-if="announcementList.length > 0" :gutter="20">
          <el-col
            v-for="(announcement, index) in announcementList"
            :key="index"
            :md="8"
          >
            <LadCard
              :item="announcement"
              :base="base"
              :to="announcement.permalink"
            />
          </el-col>
        </el-row>

        <el-row v-else class="text-center">
          <h3 class="no-data-title">{{ $t(`${base}.no_data`) }}</h3>
          <svg-icon :name="`announcement/no-data`" class="sprite-icons" />
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import StaticMetaMixin from '@/utils/mixin/static-meta'

export default {
  name: 'LadAnnouncement',
  components: {
    LadCard: () =>
      import(/* webpackChunkName: "lad-card" */ '@/components/card/index'),
    LadTextCover: () =>
      import(
        /* webpackChunkName: "lad-text-cover" */ '@/components/cover/text'
      ),
  },
  mixins: [StaticMetaMixin],
  async asyncData({ store }) {
    await store.dispatch('announcement/getList')
  },
  data() {
    return {
      base: 'announcement',
    }
  },
  computed: {
    ...mapState('announcement', ['announcementList']),
    cover() {
      return {
        src: `${process.env.DO_SPACES_CDN_ENDPOINT}/web-client/covers/torres-del-paine.jpg`,
        srcset: `${process.env.DO_SPACES_CDN_ENDPOINT}/web-client/covers/torres-del-paine.jpg 1x`,
        title: this.$t(`${this.base}.meta.title`),
        imgMinHeight: 600,
        imgMaxWidth: this.isMobile ? 900 : 1920,
      }
    },
  },
}
</script>

<style lang="scss">
.section-announcement {
  .no-data-title {
    font-size: 2rem;
  }
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-link {
    width: 100% !important;
    .el-link--inner {
      width: 100% !important;
    }
  }
}
</style>
